export default __webpack_public_path__ + "static/media/01.ba148183.jpg";